/* Whole-set removal for the grouped bundle card in the Rebuy Smart Cart.

   The card's X has to drop several Shopify lines at once. Calling Rebuy's
   removeItem() in a loop fires N concurrent /cart/change.js requests, and the
   drawer ends up rendering whichever response lands last — often with rows that
   are already gone. One /cart/update.js call zeroes every line in a single
   request, then SmartCart.setCart re-renders from the authoritative cart. */
(function () {
  var removing = false;

  function refreshSmartCart(cart) {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (smartCart && typeof smartCart.setCart === 'function') {
      smartCart.setCart(cart);
    }
    if (typeof window.updateCartCount === 'function') {
      try { window.updateCartCount(); } catch (e) { /* optional theme helper */ }
    }
  }

  /* Line keys are not stable in this shop — they are rehashed on every cart
     mutation — so Rebuy's cached copy of the cart can hand us keys that now
     belong to different lines. Resolve them from a fresh cart by _bundle_id. */
  function currentKeys(items) {
    var bundleId = ((items[0] || {}).properties || {})._bundle_id;
    var fallback = items.map(function (item) { return item.key; });

    if (!bundleId) return Promise.resolve(fallback);

    return fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var keys = (cart.items || [])
          .filter(function (line) {
            return (line.properties || {})._bundle_id === bundleId;
          })
          .map(function (line) { return line.key; });
        return keys.length ? keys : fallback;
      })
      .catch(function () { return fallback; });
  }

  window.KromaByobCart = {
    removeSet: function (items) {
      if (removing || !items || !items.length) return Promise.resolve();
      removing = true;

      return currentKeys(items)
        .then(function (keys) {
          var updates = {};
          keys.forEach(function (key) {
            if (key) updates[key] = 0;
          });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(refreshSmartCart)
        .catch(function (error) {
          console.error('[byob-cart] removeSet:', error);
        })
        .finally(function () {
          removing = false;
        });
    }
  };
})();
